<div class="d-flex justify-content-between">
  <div class="invoice-heading my-3">Invoice</div>
  <div class="d-flex">
    <button mat-icon-button (click)="dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
</div>

<div id="invoice">
  <div class="d-flex align-items-start mt-4">
    <img
      src="assets\images/Pillway_Your-Modern-Pharmacy.png"
      alt="pillway icon"
    />
  </div>
  <div class="d-flex align-items-start justify-content-between mt-4">
    <div class="main-heading">
      {{ summary.Pharmacy }}
    </div>
    <div class="d-flex">
      <div class="card-sub-heading">Patient:</div>
      <div class="card-sub-heading ml-2">
        {{ summary.FirstName }} {{ summary.LastName }}
      </div>
    </div>
  </div>
  <div class="mt-4 border-bottom pb-4">
    <div class="d-flex justify-content-between">
      <div class="align-items-start">
        <div class="card-sub-heading black mt-1">
          {{ summary.StreetNumber }} {{ summary.StreetName }}
          {{ summary.City }}
          {{ summary.Prov }} {{ summary.Postal }}
          {{ summary.Country }}
        </div>
      </div>
      <div class="d-flex flex-column align-items-end">
        <div class="card-sub-heading black mt-1">
          {{ summary.Address1 }} + {{ summary.Address2 }}
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <div class="align-items-start"></div>
      <div class="d-flex flex-column align-items-end">
        <div class="card-sub-heading black mt-1">
          {{ summary.EMail }}
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <div class="align-items-start">
        <div class="card-sub-heading black mt-1">
          +{{ summary.CountryCode }} {{ summary.PharmacyPhone }}
        </div>
      </div>
      <div class="d-flex flex-column align-items-end">
        <div class="card-sub-heading black mt-1">
          {{ summary.Phone.Phone }}
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex row mt-4 border-bottom pb-4">
    <div class="col-md-6">
      <div class="d-flex justify-content-between">
        <div class="grey">Order ID:</div>
        <div class="black">
          {{ summary.OrderID }}
        </div>
      </div>
      <div class="d-flex justify-content-between mt-2">
        <div class="grey">Date</div>
        <div class="black">
          {{ summary.Date }}
        </div>
      </div>
      <div class="d-flex justify-content-between mt-2">
        <div class="grey">Time</div>
        <div class="black">{{ summary.Time }}</div>
      </div>
    </div>
  </div>
  <div class="pagination-table my-3">
    <table class="tableInvoice" aria-describedby="Invoice Table">
      <thead>
        <tr>
          <th>Product</th>
          <th>Tax Code</th>
          <th>Quality</th>
          <th>Coverage</th>
          <th>You Pay</th>
        </tr>
      </thead>
      <tbody class="border-bottom pb-2">
        <tr *ngFor="let item of summary.Drugs">
          <td>{{ item.DrugBrandName }}</td>
          <td>{{ item.Tax }}</td>
          <td>{{ item.DispQty }}</td>
          <td>{{ item.Coverage }}</td>
          <td>{{ item.YouPay }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex row">
    <div class="col-md-8 d-flex justify-content-start align-items-start">
      <div class="grey">Subtotal</div>
    </div>
    <div class="col-md-2">
      <div class="black">${{ summary.CoverageSubtotal }}</div>
    </div>
    <div class="col-md-2">
      <div class="black">${{ summary.YouPaySubtotal }}</div>
    </div>
  </div>

  <div *ngIf="summary.Taxes?.sum">
    <div class="d-flex row mt-2" *ngFor="let item of summary.Taxes.sum">
      <div class="col-md-8 d-flex justify-content-start align-items-start">
        <div class="grey">{{ item.name }}</div>
      </div>
      <div class="col-md-2">
        <div class="black">${{ item.value }}</div>
      </div>
    </div>
  </div>

  <div class="d-flex row mt-2">
    <div class="col-md-8 d-flex justify-content-start align-items-start">
      <div class="grey">Total</div>
    </div>
    <div class="col-md-2">
      <div class="black">${{ summary.CoverageSubtotal }}</div>
    </div>
    <div class="col-md-2">
      <div class="black total p-2">${{ summary.YouPayTotal }}</div>
    </div>
  </div>

  <div *ngIf="summary.Insurances?.sum">
    <div class="d-flex row mt-2" *ngFor="let item of summary.Insurances.sum">
      <div class="col-md-8 d-flex justify-content-start align-items-start">
        <div class="grey">Insurance {{ item.name }}</div>
      </div>
      <div class="col-md-2">
        <div class="black">${{ item.value }}</div>
      </div>
    </div>
  </div>

  <div class="d-flex row border-top p-2 mt-4" *ngIf="summary.Payments?.amount">
    <div class="col-md-10 d-flex justify-content-start align-items-start mt-3">
      <div class="card-sub-heading d-flex justify-content-start">
        {{ summary.Payments.card?.card_brand }} *{{
          summary.Payments.card?.last_4
        }}
      </div>
    </div>
    <div class="col-md-2 mt-3 d-flex">
      <div class="card-sub-heading">${{ summary.Payments.amount }}</div>
    </div>
  </div>
</div>
